// src/utils/zodiacData.js
export const zodiacData = {
  aries: {
    name: "Aries",
    element: "Fire",
    planet: "Mars",
    symbol: "♈",
    dates: "Mar 21 - Apr 19",
    description: "Courageous, determined, confident, enthusiastic, optimistic, honest, passionate",
    strengths: ["Courageous", "Determined", "Confident", "Optimistic"],
    weaknesses: ["Impatient", "Moody", "Short-tempered", "Impulsive"],
    stone: "Diamond",
    luckyNumbers: [1, 9],
    career: "Natural leaders who excel in competitive environments. They are ambitious and thrive in careers that allow them to take initiative and lead.",
    health: "Generally robust health with good energy levels. Need to be careful of stress-related issues and maintain a balanced lifestyle.",
    love: "Passionate and direct in relationships. Value honesty and excitement, and seek partners who can match their energy.",
    family: "Protective and loyal to family members. Value family traditions and are often the leaders in family situations.",
    personality: "Aries are born leaders, always ready to take on challenges head-on. They are passionate, motivated, and confident.",
    famous: "Lady Gaga, Robert Downey Jr., Mariah Carey"
  },
  taurus: {
    name: "Taurus",
    element: "Earth",
    planet: "Venus",
    symbol: "♉",
    dates: "Apr 20 - May 20",
    description: "Reliable, patient, practical, devoted, responsible, stable",
    strengths: ["Reliable", "Patient", "Practical", "Devoted"],
    weaknesses: ["Stubborn", "Possessive", "Uncompromising", "Materialistic"],
    stone: "Emerald",
    luckyNumbers: [2, 6],
    career: "Excel in finance, arts, agriculture, and real estate. They are methodical, patient, and have excellent financial sense.",
    health: "Strong constitution but need to watch for throat issues and maintain regular exercise routines.",
    love: "Loyal and sensual partners who seek stability and long-term commitment in relationships.",
    family: "Value family traditions and security. They are often the rock of the family, providing stability and support.",
    personality: "Taurus individuals are grounded, reliable, and love the finer things in life. They value stability and comfort.",
    famous: "Adele, David Beckham, Queen Elizabeth II"
  },
  gemini: {
    name: "Gemini",
    element: "Air",
    planet: "Mercury",
    symbol: "♊",
    dates: "May 21 - Jun 20",
    description: "Versatile, expressive, curious, affectionate, kind, playful",
    strengths: ["Adaptable", "Communicative", "Intellectual", "Witty"],
    weaknesses: ["Nervous", "Inconsistent", "Indecisive", "Superficial"],
    stone: "Pearl",
    luckyNumbers: [5, 7],
    career: "Thrive in media, communication, writing, and teaching. They are excellent communicators and quick learners.",
    health: "Prone to anxiety and nervous disorders. Need regular mental stimulation and stress management.",
    love: "Need mental stimulation and variety in relationships. They are communicative and value intellectual connection.",
    family: "Sociable and communicative with family. They keep family connections lively and interesting.",
    personality: "Geminis are the social butterflies of the zodiac - curious, adaptable, and always seeking new experiences.",
    famous: "Angelina Jolie, Kanye West, Marilyn Monroe"
  },
  cancer: {
    name: "Cancer",
    element: "Water",
    planet: "Moon",
    symbol: "♋",
    dates: "Jun 21 - Jul 22",
    description: "Intuitive, emotional, intelligent, protective, sympathetic, nurturing",
    strengths: ["Loyal", "Emotional", "Persuasive", "Caring"],
    weaknesses: ["Moody", "Pessimistic", "Suspicious", "Manipulative"],
    stone: "Ruby",
    luckyNumbers: [2, 7],
    career: "Excel in caregiving professions, hospitality, real estate, and psychology. They are intuitive and nurturing.",
    health: "Need to watch for digestive issues and emotional eating. Regular emotional check-ins are important.",
    love: "Deeply emotional and seek security in relationships. They are nurturing and protective partners.",
    family: "Extremely family-oriented. They are the caregivers and emotional anchors of the family.",
    personality: "Cancers are deeply emotional, intuitive, and nurturing. They value home and family above all.",
    famous: "Princess Diana, Tom Cruise, Meryl Streep"
  },
  leo: {
    name: "Leo",
    element: "Fire",
    planet: "Sun",
    symbol: "♌",
    dates: "Jul 23 - Aug 22",
    description: "Creative, passionate, generous, warm-hearted, cheerful, humorous",
    strengths: ["Creative", "Passionate", "Generous", "Warm-hearted"],
    weaknesses: ["Arrogant", "Stubborn", "Self-centered", "Lazy"],
    stone: "Peridot",
    luckyNumbers: [1, 4],
    career: "Natural performers who excel in entertainment, leadership roles, teaching, and creative fields.",
    health: "Good vitality but need to watch for heart and back issues. Regular exercise is beneficial.",
    love: "Romantic and dramatic in love. They seek admiration and excitement in relationships.",
    family: "Proud and protective of family. They love to celebrate family achievements and milestones.",
    personality: "Leos are natural-born leaders who love the spotlight. They are generous, warm, and love to be admired.",
    famous: "Barack Obama, Jennifer Lopez, Madonna"
  },
  virgo: {
    name: "Virgo",
    element: "Earth",
    planet: "Mercury",
    symbol: "♍",
    dates: "Aug 23 - Sep 22",
    description: "Loyal, analytical, kind, hardworking, practical, helpful",
    strengths: ["Loyal", "Analytical", "Kind", "Hardworking"],
    weaknesses: ["Worrier", "Critical", "Shy", "Overly perfectionist"],
    stone: "Sapphire",
    luckyNumbers: [5, 14],
    career: "Excel in healthcare, analysis, research, and service industries. They are meticulous and detail-oriented.",
    health: "Need to manage stress and perfectionism. Regular routines and healthy eating are important.",
    love: "Practical and loyal in relationships. They show love through acts of service and attention to detail.",
    family: "Dependable and helpful in family matters. They often take on organizing and caretaking roles.",
    personality: "Virgos are analytical, practical, and perfectionists. They have a keen eye for detail and love to be helpful.",
    famous: "Beyoncé, Keanu Reeves, Mother Teresa"
  },
  libra: {
    name: "Libra",
    element: "Air",
    planet: "Venus",
    symbol: "♎",
    dates: "Sep 23 - Oct 22",
    description: "Cooperative, diplomatic, gracious, fair-minded, social, idealistic",
    strengths: ["Cooperative", "Diplomatic", "Gracious", "Fair-minded"],
    weaknesses: ["Indecisive", "Avoids confrontations", "Self-pitying", "Unreliable"],
    stone: "Opal",
    luckyNumbers: [6, 15],
    career: "Excel in law, diplomacy, arts, and counseling. They are natural peacemakers and negotiators.",
    health: "Need balance in all aspects. Regular social interaction and harmony are important for wellbeing.",
    love: "Romantic and seek harmony in relationships. They value partnership and beauty.",
    family: "Peacemakers in the family. They work hard to maintain harmony and balance in family relationships.",
    personality: "Libras are the diplomats of the zodiac - charming, fair, and always seeking balance and harmony.",
    famous: "Will Smith, Kim Kardashian, Mahatma Gandhi"
  },
  scorpio: {
    name: "Scorpio",
    element: "Water",
    planet: "Pluto",
    symbol: "♏",
    dates: "Oct 23 - Nov 21",
    description: "Resourceful, brave, passionate, stubborn, loyal, intuitive",
    strengths: ["Resourceful", "Brave", "Passionate", "Loyal"],
    weaknesses: ["Distrusting", "Jealous", "Secretive", "Manipulative"],
    stone: "Topaz",
    luckyNumbers: [8, 11],
    career: "Excel in investigation, psychology, research, and entrepreneurship. They are intense and focused.",
    health: "Need to manage intense emotions. Regular emotional release and privacy are important.",
    love: "Intense and passionate in relationships. They seek deep emotional and spiritual connections.",
    family: "Deeply protective of family. They value privacy and loyalty in family relationships.",
    personality: "Scorpios are passionate, mysterious, and intense. They have incredible depth and emotional intelligence.",
    famous: "Julia Roberts, Leonardo DiCaprio, Bill Gates"
  },
  sagittarius: {
    name: "Sagittarius",
    element: "Fire",
    planet: "Jupiter",
    symbol: "♐",
    dates: "Nov 22 - Dec 21",
    description: "Generous, idealistic, great sense of humor, adventurous, honest, intellectual",
    strengths: ["Generous", "Idealistic", "Humorous", "Adventurous"],
    weaknesses: ["Promises more than delivers", "Impatient", "Tactless", "Restless"],
    stone: "Turquoise",
    luckyNumbers: [3, 7],
    career: "Excel in travel, education, philosophy, and sports. They are adventurous and freedom-loving.",
    health: "Good overall health but need to avoid overindulgence. Regular adventure and exploration are important.",
    love: "Freedom-loving and honest in relationships. They value independence and intellectual stimulation.",
    family: "Bring adventure and optimism to the family. They encourage family members to explore and grow.",
    personality: "Sagittarians are the adventurers and philosophers of the zodiac - optimistic, freedom-loving, and always seeking truth.",
    famous: "Taylor Swift, Brad Pitt, Winston Churchill"
  },
  capricorn: {
    name: "Capricorn",
    element: "Earth",
    planet: "Saturn",
    symbol: "♑",
    dates: "Dec 22 - Jan 19",
    description: "Responsible, disciplined, self-control, good managers, ambitious, patient",
    strengths: ["Responsible", "Disciplined", "Self-controlled", "Ambitious"],
    weaknesses: ["Know-it-all", "Unforgiving", "Condescending", "Expects the worst"],
    stone: "Garnet",
    luckyNumbers: [4, 8],
    career: "Excel in business, management, politics, and finance. They are disciplined and ambitious.",
    health: "Need to manage stress from overwork. Regular breaks and self-care are important.",
    love: "Serious and committed in relationships. They value stability and long-term planning.",
    family: "Provide stability and structure to the family. They often take on responsible roles.",
    personality: "Capricorns are ambitious, disciplined, and responsible. They are the CEOs of the zodiac.",
    famous: "Michelle Obama, Elvis Presley, Muhammad Ali"
  },
  aquarius: {
    name: "Aquarius",
    element: "Air",
    planet: "Uranus",
    symbol: "♒",
    dates: "Jan 20 - Feb 18",
    description: "Progressive, original, independent, humanitarian, inventive, intellectual",
    strengths: ["Progressive", "Original", "Independent", "Humanitarian"],
    weaknesses: ["Runs from emotional expression", "Temperamental", "Uncompromising", "Aloof"],
    stone: "Amethyst",
    luckyNumbers: [4, 7],
    career: "Excel in technology, innovation, social work, and science. They are forward-thinking and humanitarian.",
    health: "Need to connect with emotions. Regular social causes and intellectual stimulation are important.",
    love: "Independent and intellectual in relationships. They value friendship and freedom.",
    family: "Bring innovation and progressive ideas to the family. They value individuality in family members.",
    personality: "Aquarians are the humanitarians and innovators of the zodiac - progressive, independent, and intellectually curious.",
    famous: "Oprah Winfrey, Cristiano Ronaldo, Abraham Lincoln"
  },
  pisces: {
    name: "Pisces",
    element: "Water",
    planet: "Neptune",
    symbol: "♓",
    dates: "Feb 19 - Mar 20",
    description: "Compassionate, artistic, intuitive, gentle, wise, musical",
    strengths: ["Compassionate", "Artistic", "Intuitive", "Gentle"],
    weaknesses: ["Fearful", "Overly trusting", "Sad", "Escapist"],
    stone: "Aquamarine",
    luckyNumbers: [3, 7],
    career: "Excel in arts, healing professions, spirituality, and music. They are creative and compassionate.",
    health: "Need to ground emotions and avoid escapism. Regular creative expression is important.",
    love: "Romantic and spiritual in relationships. They seek deep emotional and soul connections.",
    family: "Provide emotional support and compassion to the family. They are often the peacemakers.",
    personality: "Pisces are the dreamers and artists of the zodiac - compassionate, intuitive, and deeply spiritual.",
    famous: "Rihanna, Albert Einstein, Steve Jobs"
  },
  unknown: {
    name: "Unknown",
    element: "Unknown",
    planet: "Unknown",
    symbol: "?",
    dates: "Unknown",
    description: "Zodiac sign information not available",
    strengths: [],
    weaknesses: [],
    stone: "Unknown",
    luckyNumbers: [],
    career: "Information not available",
    health: "Information not available",
    love: "Information not available",
    family: "Information not available",
    personality: "Information not available",
    famous: "Unknown"
  }
};

// Helper function to get zodiac info by sign name
export const getZodiacInfo = (signName) => {
  if (!signName) return zodiacData.unknown;
  
  const key = signName.toLowerCase();
  return zodiacData[key] || zodiacData.unknown;
};

// Get zodiac color by element
export const getZodiacColor = (element) => {
  switch(element?.toLowerCase()) {
    case 'fire': return '#DC2626';
    case 'earth': return '#166534';
    case 'air': return '#7C3AED';
    case 'water': return '#2563EB';
    default: return '#94A3B8';
  }
};
